import clsx from "clsx";
import { memo } from "react";

interface IProps {
  tabName: string;
  activeTabName: string;
  onClick: () => void;
}

export const CommandTab = memo(({ tabName, activeTabName, onClick }: IProps) => {
  return (
    <div
      className="px-10 flex flex-col items-center justify-center"
      onClick={onClick}
    >
      <span
        className={clsx({
          "text-base font-medium": tabName === activeTabName,
          "text-gray999 text-sm": tabName !== activeTabName,
        })}
      >
        {tabName}
      </span>
      <span
        className={clsx("w-6 h-[1px] mt-1 inline-block", {
          "bg-primary": tabName === activeTabName,
          "bg-transparent": tabName !== activeTabName,
        })}
      ></span>
    </div>
  );
});
